import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollText } from 'lucide-react';
import { questGuidePath, questsServedBy } from '../../utils/npcQuests';
import type { WorldData } from '../../types/world';

/** Misiones que atiende el NPC (37_quest_rules.npc_monster_id). Independiente de su ubicación. */
export function NpcQuestServices({
  w,
  monsterId
}: {
  w?: WorldData;
  monsterId?: number;
}) {
  const quests = questsServedBy(w, monsterId);
  if (!quests.length) return null;
  return <div data-id="element-1648" data-mp="31iujrufvaics">
      <p className="mb-1.5 text-xs font-semibold text-gray-400" data-id="element-1649" data-mp="31j4efvbuxdot">Misiones que atiende</p>
      <ul className="space-y-1.5" data-id="element-1650" data-mp="3fi3wgk4v6uc0">
        {quests.map(q => {
        const path = questGuidePath(q.questId);
        return <li key={q.questId} className="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-white/[0.04] px-2.5 py-2 text-sm" data-id="element-1651" data-mp="3aihooq7t26al">
              <span className="flex min-w-0 items-start gap-2 text-white" data-id="element-1652" data-mp="pt2081w26to4">
                <ScrollText className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-1653" data-mp="pssamfexeoiy" />
                <span className="min-w-0" data-id="element-1654" data-mp="3bc2wkxb107j7">
                  <span className="block font-semibold" data-id="element-1655" data-mp="3fdernico5kys">{q.title}</span>
                  <span className="block text-xs text-gray-400" data-id="element-1656" data-mp="3ffsmpr7cmx6c">
                    {[q.levelMin !== undefined ? `Desde nivel ${q.levelMin}` : '', q.requiredQuestId !== undefined ? `Requiere la misión ${q.requiredQuestId}` : ''].filter(Boolean).join(' · ') || 'Requisitos en la guía de la misión'}
                  </span>
                </span>
              </span>
              {path && <Link to={path} className="text-xs font-semibold text-[#D4AF37] underline-offset-4 hover:underline" data-id="element-1657" data-mp="2wl3u840saf82">
                  Abrir misión
                </Link>}
            </li>;
      })}
      </ul>
      <p className="mt-1.5 text-xs text-gray-500" data-id="element-1658" data-mp="28ydu587zwuq3">Confirmado por configuración · 08/10/2026 (37_quest_rules). Clase, evolución y misión previa se filtran en la guía de evoluciones.</p>
    </div>;
}